export default Object.freeze({
    MAXSCALE_CONNECT_PORT: 8989,
})
